import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import * as styles from './FreshPromoList.css';
import { INewbuildingPromo } from '../../types/promosPage';
import { Address } from '../Address';
import { FreshPromoCard } from '../FreshPromoCard';
import { RoundArrowLeft } from '../RoundArrowLeft';
import { RoundArrowRight } from '../RoundArrowRight';
import { Section } from '../Section';
import { Underground } from '../Underground';
import { VerticalSlider } from '../VerticalSlider';

interface IFreshPromoListProps {
  title: string;
  promoList: INewbuildingPromo[];
  onListShow(): void;
  onCardClick(promo: INewbuildingPromo): void;
}

export const FreshPromoList: React.FC<IFreshPromoListProps> = ({ title, promoList, onListShow, onCardClick }) => {
  return (
    <Section title={title} data-testid="FreshPromoListSection">
      <ActionAfterViewObserver triggerOnce callback={onListShow} wrapper={false}>
        <div className={styles['container']}>
          <VerticalSlider
            rightArrow={RoundArrowRight}
            leftArrow={RoundArrowLeft}
            itemGap="16px"
            itemsPerDesktopScreen={4}
          >
            {promoList.map(promoItem => {
              const { image, label, location, logo, newbuildingId, newbuildingName, title } = promoItem;

              return (
                <div key={newbuildingId} className={styles['slide']} data-testid="FreshPromoCardSlide">
                  <FreshPromoCard
                    backgroundImage={image}
                    logoUrl={logo}
                    newbuildingName={newbuildingName}
                    title={title}
                    location={
                      location.metro ? (
                        <Underground underground={location.metro} />
                      ) : (
                        <Address>{location.address}</Address>
                      )
                    }
                    label={label}
                    onClick={() => onCardClick(promoItem)}
                  />
                </div>
              );
            })}
          </VerticalSlider>
        </div>
      </ActionAfterViewObserver>
    </Section>
  );
};
